module.exports = __webpack_public_path__ + "static/media/DummyCard.34aa4b4a.svg";